import React from 'react';
import type { ChecklistItemTemplate, ChecklistItemAnswerDraft, ItemStatus } from '../../../modules/checklist/types/checklistItems';
import { itemStatusLabel, itemStatusList, NOTE_MAX_LENGTH } from '../../../modules/checklist/types/checklistItems';

type ChecklistItemRowProps = {
  template: ChecklistItemTemplate;
  answer: ChecklistItemAnswerDraft;
  disabled?: boolean;
  /** Sessão em leitura (checklist concluído / entrada exibida na SAÍDA): mostra o texto, não o input. */
  readOnly?: boolean;
  onStatusChange: (key: string, status: ItemStatus) => void;
  onNoteChange: (key: string, note: string) => void;
};

const ChecklistItemRow: React.FC<ChecklistItemRowProps> = ({
  template,
  answer,
  disabled,
  readOnly,
  onStatusChange,
  onNoteChange,
}) => {
  const hasStatus = Boolean(answer.status);
  const danger = answer.status === 'DAMAGED' || answer.status === 'MISSING';

  return (
    <div className={danger ? 'items-table-row items-table-row--danger' : 'items-table-row'}>
      <div className="items-col items-col-name">
        <div className="items-name">{template.label}</div>
      </div>

      <div className="items-col items-col-control">
        <div className="items-status-group" role="radiogroup" aria-label={`Status de ${template.label}`}>
          {itemStatusList.map((status) => (
            <button
              key={status}
              type="button"
              className={answer.status === status ? 'items-status-btn active' : 'items-status-btn'}
              onClick={() => onStatusChange(template.key, status)}
              disabled={disabled}
              aria-pressed={answer.status === status}
            >
              {itemStatusLabel[status]}
            </button>
          ))}
        </div>
        <div className="items-row-meta">
          <span className={hasStatus ? `items-chip items-chip-${String(answer.status).toLowerCase()}` : 'items-chip'}>
            {hasStatus ? itemStatusLabel[answer.status as ItemStatus] : 'Sem resposta'}
          </span>
        </div>
      </div>

      {/* Observação é opcional e disponível em todos os itens, para qualquer status (at-34). */}
      <div className="items-col items-col-note">
        {readOnly ? (
          answer.note ? (
            <span className="items-note-text">{answer.note}</span>
          ) : (
            <span className="items-note-empty">—</span>
          )
        ) : (
          <input
            className="items-note-input"
            value={answer.note || ''}
            disabled={disabled}
            maxLength={NOTE_MAX_LENGTH}
            placeholder="Observação (opcional)"
            aria-label={`Observação de ${template.label}`}
            onChange={(e) => onNoteChange(template.key, e.target.value)}
          />
        )}
      </div>
    </div>
  );
};

export default ChecklistItemRow;
